import { Directive, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';

import { HtmlUtil } from './html-util';

@Directive({
  selector: '[appAnimateOpen]'
})
export class AnimateOpenDirective implements OnInit, OnChanges {

  private isTable;

  @Input() isOpen = false;
  @Input() maxDisplayRows? = -1;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    const element = this.el.nativeElement as HTMLElement;
    element.style.height = '0';
    element.style.overflow = 'hidden';
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange}) {
    if (this.isTable === undefined) {
      this.isTable = this.isDirectiveWrappingTableElement();
    }

    const element = this.el.nativeElement as HTMLElement,
          openChanges = changes['isOpen'];

    if (openChanges) {
      if (openChanges.currentValue) {
        // set the height and styles
        if (this.isTable) {
          // table buildup and height-style setting
          setTimeout(() => {
            this.setTableDisplayHeightStyle(element);
          }, 10);
        } else {
          // for landing page case category option list
          element.style.height = (this.getChildElementHeight() + 10).toString() + 'px';
        }

        // set transitions
        element.style.transition = 'height 0.5s';
        element.style.transitionDelay = '.1s';
      } else {
        element.style.height = '0';
        element.style.transition = 'height 0.6s';
      }
    }
  }

  private getChildElementHeight(): number {
    let totalHeight = 0;
    const element = this.el.nativeElement as HTMLElement,
        childCount = element.children.length;

    for (let i = 0; i < childCount; i++) {
      const childElement = element.children[i] as HTMLElement;
      totalHeight += childElement.offsetHeight;
    }
    return totalHeight;
  }


  private setTableDisplayHeightStyle(element: HTMLElement): void {
    // table and table height
    const gridTable: HTMLTableElement = element.children[0] as HTMLTableElement;
    const tableHeight: number = HtmlUtil.calculateTableDisplayHeight(gridTable, this.maxDisplayRows);

    // table tbody style
    if (gridTable.rows.length <= this.maxDisplayRows) {
      gridTable.tBodies[0].style.overflowY = 'hidden';
    }
    gridTable.tBodies[0].style.height = (tableHeight - gridTable.tHead.offsetHeight - 3) + 'px';

    // wrapper div style
    element.style.overflowY = 'hidden';
    element.style.height = (tableHeight - 3) + 'px';
  }

  @HostListener('window:resize', ['$event'])
  onResize($event) {
    // readjust the table display size based on window reszing
    if (this.isOpen && this.isTable )  {
      const element = this.el.nativeElement as HTMLElement;
      const gridTable: HTMLTableElement = element.children[0] as HTMLTableElement;
      let tableHeight = HtmlUtil.calculateTableDisplayHeight(gridTable, this.maxDisplayRows);
      gridTable.tBodies[0].style.height = (tableHeight - gridTable.tHead.offsetHeight - 3) + 'px';
      element.style.height = (tableHeight - 3) + 'px';
    }
  }

  private isDirectiveWrappingTableElement(): boolean {
    const element = this.el.nativeElement as HTMLElement;

    let tableElementDetected = false;
    for (let i = 0; i < element.childNodes.length; i++) {
      if (element.childNodes.item(i).nodeName === 'TABLE') {
        tableElementDetected = true;
        break;
      }
    }
    return tableElementDetected;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/animate-open.directive.ts